import { OrderSummary } from "../../containers/OrderHistoryContainer/types";
import useResetTimeout from "../useResetTimeout";
import { useEffect, useState } from "react";
import axios from "axios";
import useErrorHandler from "../userErrorHandler";

const useIndicativePriceSummary = (
  selectedOrder: OrderSummary,
  isReturn?: boolean
) => {
  const resetTimeout = useResetTimeout();
  const [priceSummary, setPriceSummary] = useState<any>({});
  const [priceSummaryLoading, setPriceSummaryLoading] = useState<boolean>(
    false
  );
  const setError = useErrorHandler();

  useEffect(() => {
    (async () => {
      try {
        if (
          selectedOrder &&
          selectedOrder.currency &&
          selectedOrder.branch &&
          selectedOrder.branch.company
        ) {
          setPriceSummaryLoading(true);
          const response = await axios.get(
            // `/api/currencies/${selectedOrder.currency.id}/indicative-price?currencyAmount=${selectedOrder.currencyAmount}&ts=` +
            `/api/currencies/${
              selectedOrder.currency.id
            }/indicative-price?companyId=${
              selectedOrder.branch.company.id
            }&direction=${isReturn ? 1 : 0}&currencyAmount=${
              selectedOrder.currencyAmount
            }&settlement=${selectedOrder.settlementSource}
            &ts=` + new Date().getTime()
          );
          setPriceSummary(response.data);
          setPriceSummaryLoading(false);
          resetTimeout();
        }
      } catch (err) {
        if (err.message === "Network Error") {
          document.location.href = "/";
        }
        setPriceSummaryLoading(false);
        setPriceSummary({});
        setError("Unable to read the indicative price summary", err);
      }
    })();
  }, [selectedOrder]);

  return { priceSummary, priceSummaryLoading };
};
export default useIndicativePriceSummary;
